export default  {	
	data () {
		return { 
			active: 0
		}
	},
	async created () { 
		this.searchSw.value=''
		await this.onInit()
	},
	destroyed()
	{
		this.resetCrud({state:'searchSw'})
	},
	methods:{
		async onInit()
		{
		this.searchSw.value=''
			await this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
			await this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })
				
		}
	}
}


